// extracted by mini-css-extract-plugin
export default {"color1":"#05294f","color2":"#004990","color3":"#5b78aa","color4":"#06accd","color5":"#53b4c6","color6":"#99ca3e","color7":"#909090","color8":"#5dcce1"};